<template>
  <button
    class="spinner-button"
    :class="{ active: isActive }"
    @click="handleClick"
  >
    <ArrowLink :title="cta" />
    <!-- <span class="cta">{{ cta }}</span> -->
    <span class="action">{{ action }}</span>
    <span class="spinner" />
  </button>
</template>

<script>
import ArrowLink from "../components/ArrowLink";

export default {
  name: "SpinnerButton",
  components: {
    ArrowLink
  },
  props: {
    cta: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {},
  methods: {
    handleClick: function(e) {
      console.log("handle click");
      this.$emit("clickaction");
      e.preventDefault();
      this.isActive = true;
    },
    reset: function() {
      console.log("reset");
      this.isActive = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../vars.scss";

$loadingSpinnerDiameter: 24px;
$loadingSpinnerStrokeWidth: 4px;
$loadingSpinnerStrokeColor: $action-blue;
$loadingSpinnerOpacity: 0.8;
$loadingSpinnerStrokeStyle: solid; // solid, dashed, dotted
$loadingSpinnerSpeed: 0.7s;

.spinner-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  padding-right: 0;

  .action {
    display: none;

    .active {
      display: block;
    }
  }

  .c-link--arrow {
    .active & {
      display: none;
    }
  }

  &.s-disabled {
    opacity: .5;
    pointer-events: none;
  }

  .c-link--arrow:last-child {
    margin-bottom: 0;
  }
}

.spinner {
  position: absolute;
  margin-top: .25em;
  right: calc((.25em + #{$loadingSpinnerDiameter}) * -1);
}

.active .spinner {
  display: inline-block;
  border: $loadingSpinnerStrokeWidth $loadingSpinnerStrokeStyle
    $loadingSpinnerStrokeColor;
  border-top-color: rgba(0, 0, 0, 0);
  border-left-color: rgba(0, 0, 0, 0);
  width: $loadingSpinnerDiameter - ($loadingSpinnerStrokeWidth * 2);
  height: $loadingSpinnerDiameter - ($loadingSpinnerStrokeWidth * 2);
  opacity: $loadingSpinnerOpacity;
  border-radius: 50%;
  animation: loadingSpinner $loadingSpinnerSpeed infinite linear;
  -webkit-animation: loadingSpinner $loadingSpinnerSpeed infinite linear;
}

button {
  position: relative;
  // min-height: 50px;
  // padding: 5px;
  // display: flex;
  // border: 2px solid transparent;
  // transition: border-color 0.8s;
  // width: 100%;
  // .cta,
  // .action {
  //   position: absolute;
  //   top: 5px;
  //   left: 0;
  //   right: 0;
  // }
  // .cta {
  //   opacity: 1;
  //   transition: opacity 0.3s;
  // }
  // .action {
  //   display: none;
  //   opacity: 0;
  //   transition: opacity 0.3s;
  // }

  // &.active {
  //   //border: 2px solid $action-blue;
  //   //color: white;
  //   border-color: $action-blue;
  //   .cta {
  //     opacity: 0;
  //     display: none;
  //   }
  //   .action {
  //     display: inline;
  //     opacity: 1;
  //   }
  // }
  // .spinner {
  //   //margin-top: -$loadingSpinnerDiameter / 2;
  //   //margin-left: 20px; //-$loadingSpinnerDiameter / 2;
  //   position: absolute;
  //   top: 12px;
  //   right: 10px;
  //   //top: 50%;
  //   //left: 50%;
  // }
}

button.small {
  min-height: 30px;
  max-width: 250px;
  &.active .spinner {
    //margin-top: -$loadingSpinnerDiameter / 2;
    //margin-left: 20px; //-$loadingSpinnerDiameter / 2;
    position: absolute;
    top: 6px;
    right: 10px;
    //top: 50%;
    //left: 50%;
    width: ($loadingSpinnerDiameter - ($loadingSpinnerStrokeWidth * 2)) / 2;
    height: ($loadingSpinnerDiameter - ($loadingSpinnerStrokeWidth * 2)) / 2;
  }
}

button.left {
  margin-left: -5px;
  .cta,
  .action {
    position: absolute;
    top: 5px;
    left: 5px;
    right: auto;
  }

  .spinner {
    //margin-top: -$loadingSpinnerDiameter / 2;
    //margin-left: 20px; //-$loadingSpinnerDiameter / 2;
    // position: absolute;
    // top: 12px;
    // right: 10px;
    //top: 50%;
    //left: 50%;
  }
}

@keyframes loadingSpinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
